/* unplugin-vue-components disabled */import script from "./avatarDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./avatarDialog.vue?vue&type=script&setup=true&lang=js"

import "./avatarDialog.vue?vue&type=style&index=0&id=2639d166&scoped=true&lang=scss"
import "./avatarDialog.vue?vue&type=style&index=1&id=2639d166&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2639d166"]])

export default __exports__